module.exports = __webpack_public_path__ + "img/cistus_incanus.ee29f233.jpg";